/* Amble Reservation Modal */
/* sync-check */

const US_STATES = [
  { code: 'AL', name: 'alabama' },
  { code: 'AK', name: 'alaska' },
  { code: 'AZ', name: 'arizona' },
  { code: 'AR', name: 'arkansas' },
  { code: 'CA', name: 'california' },
  { code: 'CO', name: 'colorado' },
  { code: 'CT', name: 'connecticut' },
  { code: 'DE', name: 'delaware' },
  { code: 'FL', name: 'florida' },
  { code: 'GA', name: 'georgia' },
  { code: 'HI', name: 'hawaii' },
  { code: 'ID', name: 'idaho' },
  { code: 'IL', name: 'illinois' },
  { code: 'IN', name: 'indiana' },
  { code: 'IA', name: 'iowa' },
  { code: 'KS', name: 'kansas' },
  { code: 'KY', name: 'kentucky' },
  { code: 'LA', name: 'louisiana' },
  { code: 'ME', name: 'maine' },
  { code: 'MD', name: 'maryland' },
  { code: 'MA', name: 'massachusetts' },
  { code: 'MI', name: 'michigan' },
  { code: 'MN', name: 'minnesota' },
  { code: 'MS', name: 'mississippi' },
  { code: 'MO', name: 'missouri' },
  { code: 'MT', name: 'montana' },
  { code: 'NE', name: 'nebraska' },
  { code: 'NV', name: 'nevada' },
  { code: 'NH', name: 'new hampshire' },
  { code: 'NJ', name: 'new jersey' },
  { code: 'NM', name: 'new mexico' },
  { code: 'NY', name: 'new york' },
  { code: 'NC', name: 'north carolina' },
  { code: 'ND', name: 'north dakota' },
  { code: 'OH', name: 'ohio' },
  { code: 'OK', name: 'oklahoma' },
  { code: 'OR', name: 'oregon' },
  { code: 'PA', name: 'pennsylvania' },
  { code: 'RI', name: 'rhode island' },
  { code: 'SC', name: 'south carolina' },
  { code: 'SD', name: 'south dakota' },
  { code: 'TN', name: 'tennessee' },
  { code: 'TX', name: 'texas' },
  { code: 'UT', name: 'utah' },
  { code: 'VT', name: 'vermont' },
  { code: 'VA', name: 'virginia' },
  { code: 'WA', name: 'washington' },
  { code: 'WV', name: 'west virginia' },
  { code: 'WI', name: 'wisconsin' },
  { code: 'WY', name: 'wyoming' },
  { code: 'DC', name: 'district of columbia' },
];

const COUNTRIES = [
  { code: 'AT', name: 'austria' },
  { code: 'BE', name: 'belgium' },
  { code: 'BG', name: 'bulgaria' },
  { code: 'HR', name: 'croatia' },
  { code: 'CY', name: 'cyprus' },
  { code: 'CZ', name: 'czechia' },
  { code: 'DK', name: 'denmark' },
  { code: 'EE', name: 'estonia' },
  { code: 'FI', name: 'finland' },
  { code: 'FR', name: 'france' },
  { code: 'DE', name: 'germany' },
  { code: 'GR', name: 'greece' },
  { code: 'HU', name: 'hungary' },
  { code: 'IE', name: 'ireland' },
  { code: 'IT', name: 'italy' },
  { code: 'LV', name: 'latvia' },
  { code: 'LT', name: 'lithuania' },
  { code: 'LU', name: 'luxembourg' },
  { code: 'MT', name: 'malta' },
  { code: 'NL', name: 'netherlands' },
  { code: 'PL', name: 'poland' },
  { code: 'PT', name: 'portugal' },
  { code: 'RO', name: 'romania' },
  { code: 'SK', name: 'slovakia' },
  { code: 'SI', name: 'slovenia' },
  { code: 'ES', name: 'spain' },
  { code: 'SE', name: 'sweden' },
  { code: 'GB', name: 'united kingdom' },
  { code: 'US', name: 'united states of america' },
  { code: 'AR', name: 'argentina' },
  { code: 'AU', name: 'australia' },
  { code: 'BD', name: 'bangladesh' },
  { code: 'BR', name: 'brazil' },
  { code: 'CA', name: 'canada' },
  { code: 'CL', name: 'chile' },
  { code: 'CN', name: 'china' },
  { code: 'CO', name: 'colombia' },
  { code: 'EG', name: 'egypt' },
  { code: 'HK', name: 'hong kong' },
  { code: 'IS', name: 'iceland' },
  { code: 'IN', name: 'india' },
  { code: 'ID', name: 'indonesia' },
  { code: 'IL', name: 'israel' },
  { code: 'JP', name: 'japan' },
  { code: 'KE', name: 'kenya' },
  { code: 'KW', name: 'kuwait' },
  { code: 'MA', name: 'morocco' },
  { code: 'MX', name: 'mexico' },
  { code: 'MY', name: 'malaysia' },
  { code: 'NZ', name: 'new zealand' },
  { code: 'NG', name: 'nigeria' },
  { code: 'NO', name: 'norway' },
  { code: 'PK', name: 'pakistan' },
  { code: 'PH', name: 'philippines' },
  { code: 'QA', name: 'qatar' },
  { code: 'SA', name: 'saudi arabia' },
  { code: 'SG', name: 'singapore' },
  { code: 'ZA', name: 'south africa' },
  { code: 'KR', name: 'south korea' },
  { code: 'CH', name: 'switzerland' },
  { code: 'TW', name: 'taiwan' },
  { code: 'TH', name: 'thailand' },
  { code: 'TR', name: 'turkey' },
  { code: 'AE', name: 'united arab emirates' },
  { code: 'VN', name: 'vietnam' },
];

class AmbleReservation extends HTMLElement {
  #scrollY = 0;
  #eligible = new Set();

  get #dialog() { return this.querySelector('dialog'); }

  connectedCallback() {
    this.#eligible = new Set(
      (this.dataset.eligible || '')
        .split(',')
        .map(c => c.trim().toUpperCase())
        .filter(Boolean)
    );

    this.#populateCountries();
    this.#populateStates();
    document.addEventListener('click', this.#onDocumentClick);
    this.addEventListener('click', this.#onInternalClick);
    this.querySelector('#amble-res-country')?.addEventListener('change', this.#onCountryChange);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.#onDocumentClick);
  }

  // ── Open / close ────────────────────────────────────────────────────────────

  open(view = 'consumer') {
    this.#scrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    this.#reset();
    if (view !== 'consumer') this.#showView(view);
    this.#dialog?.showModal();
  }

  async close() {
    const dialog = this.#dialog;
    if (!dialog?.open) return;

    dialog.classList.add('is-closing');
    await new Promise(resolve => {
      const fin = () => resolve();
      dialog.addEventListener('animationend', fin, { once: true });
      setTimeout(fin, 350);
    });

    dialog.classList.remove('is-closing');
    dialog.close();
    document.body.style.overflow = '';
    window.scrollTo({ top: this.#scrollY, behavior: 'instant' });
  }

  // ── Event handlers ───────────────────────────────────────────────────────────

  #onDocumentClick = (e) => {
    const el = e.target.closest('[data-open-reservation]');
    if (el) this.open(el.dataset.openReservation || 'consumer');
  };

  #onInternalClick = (e) => {
    const action = e.target.closest('[data-res-action]')?.dataset.resAction;
    switch (action) {
      case 'close':           this.close(); break;
      case 'show-business':   this.#showView('business'); break;
      case 'show-consumer':   this.#showView('consumer'); break;
      case 'reserve':         this.#handleReserve(); break;
      case 'waitlist':        this.#handleWaitlist(); break;
      case 'submit-business': this.#handleBusiness(); break;
    }
  };

  #onCountryChange = () => {
    const code = this.querySelector('#amble-res-country')?.value;
    const eligible    = code && this.#eligible.has(code);
    const notice      = this.querySelector('#amble-res-notice');
    const ctaElig     = this.querySelector('#amble-res-cta-eligible');
    const ctaWait     = this.querySelector('#amble-res-cta-waitlist');
    const stateWrap   = this.querySelector('#amble-res-state-wrap');
    const stateEl     = this.querySelector('#amble-res-state');
    const addressWrap = this.querySelector('#amble-res-address-wrap');

    if (notice)    notice.hidden    = eligible || !code;
    if (ctaElig)   ctaElig.hidden   = !eligible;
    if (ctaWait)   ctaWait.hidden   = eligible || !code;

    const isUS = code === 'US';
    if (stateWrap) stateWrap.hidden = !isUS;
    if (stateEl && !isUS) stateEl.value = '';

    if (addressWrap) addressWrap.hidden = !eligible;
    if (!eligible) {
      const address1  = this.querySelector('#amble-res-address1');
      const city      = this.querySelector('#amble-res-city');
      const postcode  = this.querySelector('#amble-res-postcode');
      if (address1) address1.value = '';
      if (city)     city.value     = '';
      if (postcode) postcode.value = '';
    }
  };

  // ── View switching ───────────────────────────────────────────────────────────

  #showView(name) {
    this.querySelectorAll('[data-res-view]').forEach(el => {
      el.hidden = el.dataset.resView !== name;
    });
  }

  // ── Actions ──────────────────────────────────────────────────────────────────

  async #handleReserve() {
    const name     = this.#val('#amble-res-name');
    const email    = this.#val('#amble-res-email');
    const phone    = this.#val('#amble-res-phone');
    const country  = this.querySelector('#amble-res-country')?.value || '';
    const state    = this.querySelector('#amble-res-state')?.value || '';
    const address1 = this.#val('#amble-res-address1');
    const city     = this.#val('#amble-res-city');
    const postcode = this.#val('#amble-res-postcode');

    let valid = true;
    if (!name)                    { this.#setError('#amble-res-name',  'please enter your name');           valid = false; }
    if (!email)                   { this.#setError('#amble-res-email', 'please enter your email');          valid = false; }
    else if (!this.#isValidEmail(email)) { this.#setError('#amble-res-email', 'please enter a valid email'); valid = false; }
    if (country === 'US' && !state) { this.#setError('#amble-res-state', 'please select your state');       valid = false; }
    if (!address1)                 { this.#setError('#amble-res-address1', 'please enter your address');    valid = false; }
    if (!city)                     { this.#setError('#amble-res-city',     'please enter your city');       valid = false; }
    if (!postcode)                 { this.#setError('#amble-res-postcode', 'please enter your postcode');   valid = false; }
    if (!valid) return;

    const btn = this.querySelector('[data-res-action="reserve"]');
    this.#setLoading(btn, true);

    // Fire Klaviyo immediately — keepalive ensures requests survive the page redirect
    this.#submitToKlaviyo({
      name, email, phone, country, state, address1, city, postcode,
      type: 'reservation',
      company: '',
      vehicles: '',
      consent: this.#checked('#amble-res-consent'),
    });

    try {
      const variantId = parseInt(this.dataset.variantId, 10);
      const cartProperties = {
        'Customer Name':     name,
        'Customer Email':    email,
        'Customer Phone':    phone,
        'Country':           country,
        'Address':           address1,
        'City':              city,
        'Postcode':          postcode,
        'Marketing Consent': this.#checked('#amble-res-consent') ? 'yes' : 'no',
      };
      if (state) cartProperties['State'] = state;

      await fetch('/cart/clear.js', { method: 'POST' });
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1, properties: cartProperties }),
      });

      const [first, ...rest] = name.trim().split(' ');
      const params = new URLSearchParams({
        'checkout[email]':                          email,
        'checkout[shipping_address][first_name]':   first,
        'checkout[shipping_address][last_name]':    rest.join(' '),
        'checkout[shipping_address][phone]':        phone,
        'checkout[shipping_address][address1]':     address1,
        'checkout[shipping_address][city]':         city,
        'checkout[shipping_address][zip]':          postcode,
        'checkout[shipping_address][country]':      this.#countryName(country),
      });
      if (state) params.set('checkout[shipping_address][province]', this.#stateName(state));
      window.location.href = `/checkout?${params}`;

    } catch {
      window.location.href = '/cart';
    }
  }

  async #handleWaitlist() {
    const name    = this.#val('#amble-res-name');
    const email   = this.#val('#amble-res-email');
    const phone   = this.#val('#amble-res-phone');
    const country = this.querySelector('#amble-res-country')?.value || '';
    const state   = this.querySelector('#amble-res-state')?.value || '';

    let valid = true;
    if (!name)                         { this.#setError('#amble-res-name',  'please enter your name');           valid = false; }
    if (!email)                        { this.#setError('#amble-res-email', 'please enter your email');          valid = false; }
    else if (!this.#isValidEmail(email)) { this.#setError('#amble-res-email', 'please enter a valid email'); valid = false; }
    if (country === 'US' && !state) { this.#setError('#amble-res-state', 'please select your state');       valid = false; }
    if (!valid) return;

    const btn = this.querySelector('[data-res-action="waitlist"]');
    this.#setLoading(btn, true);

    await this.#submitToKlaviyo({
      name, email, phone, country, state,
      type: 'waitlist',
      company: '',
      vehicles: '',
      consent: this.#checked('#amble-res-consent'),
    });

    this.#setLoading(btn, false);
    this.#showView('thankyou-waitlist');
  }

  async #handleBusiness() {
    const email    = this.#val('#amble-res-biz-email');
    const company  = this.#val('#amble-res-biz-company');
    const phone    = this.#val('#amble-res-biz-phone');
    const vehicles = this.querySelector('#amble-res-biz-vehicles')?.value || '';

    let valid = true;
    if (!email)                        { this.#setError('#amble-res-biz-email', 'please enter your email');          valid = false; }
    else if (!this.#isValidEmail(email)) { this.#setError('#amble-res-biz-email', 'please enter a valid email'); valid = false; }
    if (!company)                      { this.#setError('#amble-res-biz-company', 'please enter your company name'); valid = false; }
    if (!vehicles)                     { this.#setError('#amble-res-biz-vehicles', 'please select number of vehicles'); valid = false; }
    if (!valid) return;

    const btn = this.querySelector('[data-res-action="submit-business"]');
    this.#setLoading(btn, true);

    await this.#submitToKlaviyo({
      name: '',
      email, phone, company, vehicles,
      country: '',
      type: 'business',
      consent: this.#checked('#amble-res-biz-consent'),
    });

    this.#setLoading(btn, false);
    this.#showView('thankyou-business');
  }

  // ── Klaviyo subscription ─────────────────────────────────────────────────────

  async #submitToKlaviyo(data) {
    const EVENT_NAMES = {
      reservation: 'Amble Reservation',
      waitlist:    'Amble Waitlist',
      business:    'Amble Business Enquiry',
    };

    const nameParts = (data.name || '').trim().split(/\s+/);
    const firstName = nameParts[0] || '';
    const lastName  = nameParts.slice(1).join(' ');

    const profileAttributes = { email: data.email };
    if (firstName) profileAttributes.first_name = firstName;
    if (lastName)  profileAttributes.last_name  = lastName;
    profileAttributes.properties = {
      amble_enquiry_type: data.type,
      marketing_consent:  data.consent,
      ...(data.phone    && { phone:    data.phone }),
      ...(data.country  && { country:  data.country }),
      ...(data.state    && { state:    data.state }),
      ...(data.address1 && { address1: data.address1 }),
      ...(data.city     && { city:     data.city }),
      ...(data.postcode && { postcode: data.postcode }),
      ...(data.company  && { company:  data.company }),
      ...(data.vehicles && { vehicles: data.vehicles }),
    };

    const eventProperties = {
      enquiry_type:      data.type,
      marketing_consent: data.consent,
      ...(data.phone    && { phone:    data.phone }),
      ...(data.country  && { country:  data.country }),
      ...(data.state    && { state:    data.state }),
      ...(data.address1 && { address1: data.address1 }),
      ...(data.city     && { city:     data.city }),
      ...(data.postcode && { postcode: data.postcode }),
      ...(data.company  && { company:  data.company }),
      ...(data.vehicles && { vehicles: data.vehicles }),
    };

    const headers = {
      'Content-Type': 'application/json',
      'revision':     '2023-02-22',
    };
    const base = 'https://a.klaviyo.com/client';
    const cid  = '?company_id=VsAjcg';

    const fetchOpts = (body) => ({
      method: 'POST',
      headers,
      keepalive: true,
      body: JSON.stringify(body),
    });

    // Fire all three in parallel — all requests are in-flight immediately,
    // keepalive ensures they survive the checkout redirect
    const requests = [
      fetch(`${base}/profiles/${cid}`, fetchOpts({
        data: { type: 'profile', attributes: profileAttributes },
      })),
    ];

    if (data.consent) {
      requests.push(fetch(`${base}/subscriptions/${cid}`, fetchOpts({
        data: {
          type: 'subscription',
          attributes: { list_id: 'UStsFV', email: data.email },
        },
      })));
    }

    requests.push(
      fetch(`${base}/events/${cid}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
        keepalive: true,
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              metric: {
                data: { type: 'metric', attributes: { name: EVENT_NAMES[data.type] || 'Amble Form Submitted' } },
              },
              profile: {
                data: { type: 'profile', attributes: { email: data.email } },
              },
              properties: eventProperties,
              time: new Date().toISOString(),
              unique_id: `${data.email}-${data.type}-${Date.now()}`,
            },
          },
        }),
      })
    );

    Promise.all(requests).catch(err => console.error('[Klaviyo] network error', err));
  }

  // ── Helpers ──────────────────────────────────────────────────────────────────

  #val(selector) {
    return (this.querySelector(selector)?.value || '').trim();
  }

  #checked(selector) {
    return !!this.querySelector(selector)?.checked;
  }

  #isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  #toTitleCase(str) {
    return str.replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1));
  }

  // Checkout's URL prefill needs Shopify's actual country/region names, not
  // our lowercase display copy — special-case the one entry that diverges.
  #countryName(code) {
    if (code === 'US') return 'United States';
    const match = COUNTRIES.find(c => c.code === code);
    return match ? this.#toTitleCase(match.name) : '';
  }

  #stateName(code) {
    const match = US_STATES.find(s => s.code === code);
    return match ? this.#toTitleCase(match.name) : '';
  }

  #setError(selector, message) {
    const el = this.querySelector(selector);
    if (!el) return;
    el.classList.add('is-error');
    if (!el.nextElementSibling?.classList.contains('amble-res__field-error')) {
      const span = document.createElement('span');
      span.className = 'amble-res__field-error';
      span.textContent = message;
      el.insertAdjacentElement('afterend', span);
    }
    el.addEventListener('input', () => this.#clearError(selector), { once: true });
  }

  #clearError(selector) {
    const el = this.querySelector(selector);
    if (!el) return;
    el.classList.remove('is-error');
    const msg = el.nextElementSibling;
    if (msg?.classList.contains('amble-res__field-error')) msg.remove();
  }

  #clearErrors() {
    this.querySelectorAll('.is-error').forEach(el => el.classList.remove('is-error'));
    this.querySelectorAll('.amble-res__field-error').forEach(el => el.remove());
  }

  #setLoading(btn, loading) {
    if (!btn) return;
    btn.disabled = loading;
    if (loading) {
      btn.dataset.originalText = btn.textContent;
      btn.textContent = '...';
    } else {
      btn.textContent = btn.dataset.originalText || btn.dataset.label || '';
    }
  }

  #shake(selector) {
    const el = this.querySelector(selector);
    if (!el) return;
    el.style.animation = 'none';
    void el.offsetWidth;
    el.style.animation = 'ambleResShake 0.4s ease';
    el.addEventListener('animationend', () => { el.style.animation = ''; }, { once: true });
  }

  #reset() {
    this.#clearErrors();
    this.querySelectorAll('.amble-res__input').forEach(el => {
      if (el.tagName === 'SELECT') el.selectedIndex = 0;
      else el.value = '';
    });
    this.querySelectorAll('.amble-res__checkbox').forEach(el => { el.checked = false; });
    const notice      = this.querySelector('#amble-res-notice');
    const ctaElig     = this.querySelector('#amble-res-cta-eligible');
    const ctaWait     = this.querySelector('#amble-res-cta-waitlist');
    const stateWrap   = this.querySelector('#amble-res-state-wrap');
    const addressWrap = this.querySelector('#amble-res-address-wrap');
    if (notice)      notice.hidden      = true;
    if (ctaElig)     { ctaElig.hidden = false; ctaElig.disabled = false; ctaElig.textContent = ctaElig.dataset.label || ''; }
    if (ctaWait)     { ctaWait.hidden = true;  ctaWait.disabled = false; ctaWait.textContent = ctaWait.dataset.label || ''; }
    if (stateWrap)   stateWrap.hidden   = true;
    if (addressWrap) addressWrap.hidden = true;
    this.#showView('consumer');
  }

  #populateCountries() {
    const select = this.querySelector('#amble-res-country');
    if (!select) return;
    const sorted = [...COUNTRIES].sort((a, b) => a.name.localeCompare(b.name));
    sorted.forEach(({ code, name }) => {
      const opt = document.createElement('option');
      opt.value = code;
      opt.textContent = name;
      select.appendChild(opt);
    });
  }

  #populateStates() {
    const select = this.querySelector('#amble-res-state');
    if (!select) return;
    US_STATES.forEach(({ code, name }) => {
      const opt = document.createElement('option');
      opt.value = code;
      opt.textContent = name;
      select.appendChild(opt);
    });
  }
}

if (!customElements.get('amble-reservation')) {
  customElements.define('amble-reservation', AmbleReservation);
}

/* Shake keyframes injected once */
if (!document.getElementById('amble-res-shake-style')) {
  const s = document.createElement('style');
  s.id = 'amble-res-shake-style';
  s.textContent = `
    @keyframes ambleResShake {
      0%,100% { transform: translateX(0); }
      20%      { transform: translateX(-6px); }
      40%      { transform: translateX(6px); }
      60%      { transform: translateX(-4px); }
      80%      { transform: translateX(4px); }
    }
  `;
  document.head.appendChild(s);
}
